// extracted by mini-css-extract-plugin
export default {"consent":"styles_consent__WoXen"};